// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1Rkn2","title":"ClientInsurance_title__1j3n5","itemText":"ClientInsurance_itemText__TCoRJ"};